import bookingCreateComponent from './booking-create.component';

const bookingCreateModule = angular
  .module('bookingCreate', [])
  .component('bookingCreate', bookingCreateComponent);

export default bookingCreateModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-create/booking-create.js
 **/